export const PERMISSIONS = {
  API_ENDPOINTS: 'api endpoints',
  PRIVATE_API_ENDPOINTS: 'private api endpoints',
  API_KEYS: 'api keys',
  MANAGE_USERS: 'manage users',
  ANALYTICS: 'analytics',
  MANAGE_ACCOUNTS: 'manage accounts',
  VIEW_ACCOUNTS: 'view accounts',
  MANAGE_TEAMS: 'manage teams',
  VIEW_TEAMS: 'view teams',
  OVERRIDE_FEATURE_ADDONS: 'override feature add-ons',
  MANAGE_SETTINGS: 'manage settings',
  MANAGE_APP_SWITCH: 'manage app switch',
  CALL_HANDLING: 'call handling',
  MANAGE_SECTIONS: 'manage sections',
  APPROVE_SECTION: 'approve section',
  INVITE: 'invite',
  SELF_JOIN_ACCOUNTS: 'self join accounts',
  RATE_APP: 'rate-app',
  MANAGE_PRODUCTS: 'manage-products',
};

export const ROLES = {
  ADMIN: 'Admin',
  DEVELOPER: 'Developer',
  USER: 'User',
  CUSTOMER: 'Customer',
};

const ADMIN_PERMISSIONS = Object.values(PERMISSIONS).filter(
  value => value !== 'approve section'
);

export const ROLE_PERMISSIONS = {
  [ROLES.ADMIN]: [...Object.values(ADMIN_PERMISSIONS)],
  [ROLES.DEVELOPER]: [
    PERMISSIONS.API_ENDPOINTS,
    PERMISSIONS.API_KEYS,
    PERMISSIONS.MANAGE_ACCOUNTS,
    PERMISSIONS.MANAGE_TEAMS,
    PERMISSIONS.OVERRIDE_FEATURE_ADDONS,
    PERMISSIONS.MANAGE_ACCOUNTS,
    PERMISSIONS.MANAGE_SETTINGS,
    PERMISSIONS.MANAGE_APP_SWITCH,
    PERMISSIONS.CALL_HANDLING,
    PERMISSIONS.MANAGE_SECTIONS,
    PERMISSIONS.INVITE,
    PERMISSIONS.SELF_JOIN_ACCOUNTS,
    PERMISSIONS.RATE_APP,
  ],
  [ROLES.USER]: [
    PERMISSIONS.MANAGE_ACCOUNTS,
    PERMISSIONS.MANAGE_TEAMS,
    PERMISSIONS.MANAGE_SETTINGS,
    PERMISSIONS.MANAGE_APP_SWITCH,
    PERMISSIONS.CALL_HANDLING,
    PERMISSIONS.MANAGE_SECTIONS,
    PERMISSIONS.INVITE,
    PERMISSIONS.SELF_JOIN_ACCOUNTS,
    PERMISSIONS.RATE_APP,
  ],
  [ROLES.CUSTOMER]: [
    PERMISSIONS.VIEW_ACCOUNTS,
    PERMISSIONS.VIEW_TEAMS,
    PERMISSIONS.APPROVE_SECTION,
  ],
};
